export default __webpack_public_path__ + "ce54a3c2e5b77ffdfa5e77d15e14a6ee.svg";